export const packageCategories = {
    state: {
        addresses: []
    },
    mutations: {
        SET_PACKAGE_CATEGORIES(state, payload) {
            state.addresses.push(payload)
        }
    },
    actions: {
        fetchPackageCategories({ commit, getters }, payload) {
            return new Promise((resolve, reject) => {
                if(getters.packageCategories(payload.warehouseId, payload.externalSupplier) === null) {
                    const supplier = payload.externalSupplier ? 1 : 0
                    this.$api.get(`b2b/v2/packages/categories/${payload.warehouseId}/${supplier}`).then(response => {
                        commit('SET_PACKAGE_CATEGORIES', {
                            packageCategories: response.data.data,
                            warehouseId: payload.warehouseId,
                            externalSupplier: payload.externalSupplier ? 1 : 0
                        })
                        resolve()
                    })
                }
            })
        }
    },
    getters: {
        packageCategories: (state, getters) => addressId => {
            let warehouseId
            let externalSupplier
            if(addressId >= 0) {
                // customer modules
                warehouseId = getters.customerAddressWarehouseId(addressId)
                externalSupplier = getters.customerAddressExternalSupplier(addressId)
            } else {
                // companies modules
                addressId = Math.abs(addressId)
                const address = getters['companies/addresses'].find(
                    address => address.id === addressId
                )
                if(address) {
                    warehouseId = address.warehouse_id
                    externalSupplier = address.external_supplier ? 1 : 0
                    addressId = 0
                }
            }
            const supplier = externalSupplier ? 1 : 0
            const idx = state.addresses.findIndex(item => item.warehouseId === warehouseId && item.externalSupplier === supplier)
            return idx !== -1 ? state.addresses[idx].packageCategories : null
        }
    }
}
